import React from 'react';
import IntercomBot from '../hooks/intercom';

const withIntercom = (Component: any) => (props: any) => {
  IntercomBot();
  return <Component {...props} />;
};

export default withIntercom;
